module.exports = __webpack_public_path__ + "img/post-item.653fbf44.svg";